import { supabase } from '@/lib/supabase'

const KEY = 'ui.christmas_snow.enabled'

export async function getChristmasSnowEnabled(): Promise<boolean> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', KEY)
    .maybeSingle()
  if (error) throw error
  const v = (data?.value as string) || 'false'
  return v === 'true'
}

export async function setChristmasSnowEnabled(on: boolean): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY, value: on ? 'true' : 'false' }, { onConflict: 'key' })
  if (error) throw error
}

